/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SentryErrorTestImport } from './routes/sentry-error-test'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as RegisterImport } from './routes/register'
import { Route as LoginImport } from './routes/login'
import { Route as DashboardImport } from './routes/_dashboard'
import { Route as DashboardIndexImport } from './routes/_dashboard.index'
import { Route as DashboardWebhooksImport } from './routes/_dashboard.webhooks'
import { Route as DashboardUserProfileImport } from './routes/_dashboard.user-profile'
import { Route as DashboardUserApprovalsImport } from './routes/_dashboard.user-approvals'
import { Route as DashboardSitesImport } from './routes/_dashboard.sites'
import { Route as DashboardSalesDashboardImport } from './routes/_dashboard.sales-dashboard'
import { Route as DashboardSalesContractsImport } from './routes/_dashboard.sales-contracts'
import { Route as DashboardSalesCalendarImport } from './routes/_dashboard.sales-calendar'
import { Route as DashboardReportProjectsImport } from './routes/_dashboard.report-projects'
import { Route as DashboardProjectsImport } from './routes/_dashboard.projects'
import { Route as DashboardLeadsDashboardImport } from './routes/_dashboard.leads-dashboard'
import { Route as DashboardLeadsImport } from './routes/_dashboard.leads'
import { Route as DashboardJournalAccountsImport } from './routes/_dashboard.journal-accounts'
import { Route as DashboardInvoiceRequestsImport } from './routes/_dashboard.invoice-requests'
import { Route as DashboardInvoicePrintTemplatesImport } from './routes/_dashboard.invoice-print-templates'
import { Route as DashboardCreateImport } from './routes/_dashboard.create'
import { Route as DashboardCollectionReportImport } from './routes/_dashboard.collection-report'
import { Route as DashboardClientsImport } from './routes/_dashboard.clients'
import { Route as DashboardChecklistsImport } from './routes/_dashboard.checklists'
import { Route as DashboardChangelogImport } from './routes/_dashboard.changelog'
import { Route as DashboardBomImport } from './routes/_dashboard.bom'
import { Route as DashboardBir2307Import } from './routes/_dashboard.bir-2307'
import { Route as DashboardUserApprovalsUserIdImport } from './routes/_dashboard.user-approvals_.$userId'
import { Route as DashboardSitesCreateImport } from './routes/_dashboard.sites_.create'
import { Route as DashboardSitesSiteIdImport } from './routes/_dashboard.sites_.$siteId'
import { Route as DashboardSalesContractsContractIdImport } from './routes/_dashboard.sales-contracts_.$contractId'
import { Route as DashboardProjectsProjectIdImport } from './routes/_dashboard.projects_.$projectId'
import { Route as DashboardLeadsImportImport } from './routes/_dashboard.leads_.import'
import { Route as DashboardLeadsLeadIdImport } from './routes/_dashboard.leads_.$leadId'
import { Route as DashboardInvoicesInvoiceIdImport } from './routes/_dashboard.invoices_.$invoiceId'
import { Route as DashboardInvoiceRequestsInvoiceRequestIdImport } from './routes/_dashboard.invoice-requests_.$invoiceRequestId'
import { Route as DashboardInvoicePrintTemplatesTemplateIdImport } from './routes/_dashboard.invoice-print-templates_.$templateId'
import { Route as DashboardChecklistsCreateImport } from './routes/_dashboard.checklists_.create'
import { Route as DashboardChecklistsChecklistIdImport } from './routes/_dashboard.checklists_.$checklistId'
import { Route as DashboardBomSupplierInfosImport } from './routes/_dashboard.bom_.supplier-infos'
import { Route as DashboardBomSupplierInfosSupplierInfoIdImport } from './routes/_dashboard.bom_.supplier-infos_.$supplierInfoId'

// Create/Update Routes

const SentryErrorTestRoute = SentryErrorTestImport.update({
  id: '/sentry-error-test',
  path: '/sentry-error-test',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const DashboardRoute = DashboardImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRoute,
} as any)

const DashboardIndexRoute = DashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardWebhooksRoute = DashboardWebhooksImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardUserProfileRoute = DashboardUserProfileImport.update({
  id: '/user-profile',
  path: '/user-profile',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardUserApprovalsRoute = DashboardUserApprovalsImport.update({
  id: '/user-approvals',
  path: '/user-approvals',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardSitesRoute = DashboardSitesImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardSalesDashboardRoute = DashboardSalesDashboardImport.update({
  id: '/sales-dashboard',
  path: '/sales-dashboard',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardSalesContractsRoute = DashboardSalesContractsImport.update({
  id: '/sales-contracts',
  path: '/sales-contracts',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardSalesCalendarRoute = DashboardSalesCalendarImport.update({
  id: '/sales-calendar',
  path: '/sales-calendar',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardReportProjectsRoute = DashboardReportProjectsImport.update({
  id: '/report-projects',
  path: '/report-projects',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardProjectsRoute = DashboardProjectsImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardLeadsDashboardRoute = DashboardLeadsDashboardImport.update({
  id: '/leads-dashboard',
  path: '/leads-dashboard',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardLeadsRoute = DashboardLeadsImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardJournalAccountsRoute = DashboardJournalAccountsImport.update({
  id: '/journal-accounts',
  path: '/journal-accounts',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardInvoiceRequestsRoute = DashboardInvoiceRequestsImport.update({
  id: '/invoice-requests',
  path: '/invoice-requests',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardInvoicePrintTemplatesRoute =
  DashboardInvoicePrintTemplatesImport.update({
    id: '/invoice-print-templates',
    path: '/invoice-print-templates',
    getParentRoute: () => DashboardRoute,
  } as any)

const DashboardCreateRoute = DashboardCreateImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardCollectionReportRoute = DashboardCollectionReportImport.update({
  id: '/collection-report',
  path: '/collection-report',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardClientsRoute = DashboardClientsImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardChecklistsRoute = DashboardChecklistsImport.update({
  id: '/checklists',
  path: '/checklists',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardChangelogRoute = DashboardChangelogImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardBomRoute = DashboardBomImport.update({
  id: '/bom',
  path: '/bom',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardBir2307Route = DashboardBir2307Import.update({
  id: '/bir-2307',
  path: '/bir-2307',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardUserApprovalsUserIdRoute =
  DashboardUserApprovalsUserIdImport.update({
    id: '/user-approvals_/$userId',
    path: '/user-approvals/$userId',
    getParentRoute: () => DashboardRoute,
  } as any)

const DashboardSitesCreateRoute = DashboardSitesCreateImport.update({
  id: '/sites_/create',
  path: '/sites/create',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardSitesSiteIdRoute = DashboardSitesSiteIdImport.update({
  id: '/sites_/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardSalesContractsContractIdRoute =
  DashboardSalesContractsContractIdImport.update({
    id: '/sales-contracts_/$contractId',
    path: '/sales-contracts/$contractId',
    getParentRoute: () => DashboardRoute,
  } as any)

const DashboardProjectsProjectIdRoute = DashboardProjectsProjectIdImport.update(
  {
    id: '/projects_/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => DashboardRoute,
  } as any,
)

const DashboardLeadsImportRoute = DashboardLeadsImportImport.update({
  id: '/leads_/import',
  path: '/leads/import',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardLeadsLeadIdRoute = DashboardLeadsLeadIdImport.update({
  id: '/leads_/$leadId',
  path: '/leads/$leadId',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardInvoicesInvoiceIdRoute = DashboardInvoicesInvoiceIdImport.update(
  {
    id: '/invoices_/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => DashboardRoute,
  } as any,
)

const DashboardInvoiceRequestsInvoiceRequestIdRoute =
  DashboardInvoiceRequestsInvoiceRequestIdImport.update({
    id: '/invoice-requests_/$invoiceRequestId',
    path: '/invoice-requests/$invoiceRequestId',
    getParentRoute: () => DashboardRoute,
  } as any)

const DashboardInvoicePrintTemplatesTemplateIdRoute =
  DashboardInvoicePrintTemplatesTemplateIdImport.update({
    id: '/invoice-print-templates_/$templateId',
    path: '/invoice-print-templates/$templateId',
    getParentRoute: () => DashboardRoute,
  } as any)

const DashboardChecklistsCreateRoute = DashboardChecklistsCreateImport.update({
  id: '/checklists_/create',
  path: '/checklists/create',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardChecklistsChecklistIdRoute =
  DashboardChecklistsChecklistIdImport.update({
    id: '/checklists_/$checklistId',
    path: '/checklists/$checklistId',
    getParentRoute: () => DashboardRoute,
  } as any)

const DashboardBomSupplierInfosRoute = DashboardBomSupplierInfosImport.update({
  id: '/bom_/supplier-infos',
  path: '/bom/supplier-infos',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardBomSupplierInfosSupplierInfoIdRoute =
  DashboardBomSupplierInfosSupplierInfoIdImport.update({
    id: '/bom_/supplier-infos_/$supplierInfoId',
    path: '/bom/supplier-infos/$supplierInfoId',
    getParentRoute: () => DashboardRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/sentry-error-test': {
      id: '/sentry-error-test'
      path: '/sentry-error-test'
      fullPath: '/sentry-error-test'
      preLoaderRoute: typeof SentryErrorTestImport
      parentRoute: typeof rootRoute
    }
    '/_dashboard/bir-2307': {
      id: '/_dashboard/bir-2307'
      path: '/bir-2307'
      fullPath: '/bir-2307'
      preLoaderRoute: typeof DashboardBir2307Import
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/bom': {
      id: '/_dashboard/bom'
      path: '/bom'
      fullPath: '/bom'
      preLoaderRoute: typeof DashboardBomImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/changelog': {
      id: '/_dashboard/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof DashboardChangelogImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/checklists': {
      id: '/_dashboard/checklists'
      path: '/checklists'
      fullPath: '/checklists'
      preLoaderRoute: typeof DashboardChecklistsImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/clients': {
      id: '/_dashboard/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof DashboardClientsImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/collection-report': {
      id: '/_dashboard/collection-report'
      path: '/collection-report'
      fullPath: '/collection-report'
      preLoaderRoute: typeof DashboardCollectionReportImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/create': {
      id: '/_dashboard/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof DashboardCreateImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/invoice-print-templates': {
      id: '/_dashboard/invoice-print-templates'
      path: '/invoice-print-templates'
      fullPath: '/invoice-print-templates'
      preLoaderRoute: typeof DashboardInvoicePrintTemplatesImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/invoice-requests': {
      id: '/_dashboard/invoice-requests'
      path: '/invoice-requests'
      fullPath: '/invoice-requests'
      preLoaderRoute: typeof DashboardInvoiceRequestsImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/journal-accounts': {
      id: '/_dashboard/journal-accounts'
      path: '/journal-accounts'
      fullPath: '/journal-accounts'
      preLoaderRoute: typeof DashboardJournalAccountsImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/leads': {
      id: '/_dashboard/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof DashboardLeadsImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/leads-dashboard': {
      id: '/_dashboard/leads-dashboard'
      path: '/leads-dashboard'
      fullPath: '/leads-dashboard'
      preLoaderRoute: typeof DashboardLeadsDashboardImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/projects': {
      id: '/_dashboard/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof DashboardProjectsImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/report-projects': {
      id: '/_dashboard/report-projects'
      path: '/report-projects'
      fullPath: '/report-projects'
      preLoaderRoute: typeof DashboardReportProjectsImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/sales-calendar': {
      id: '/_dashboard/sales-calendar'
      path: '/sales-calendar'
      fullPath: '/sales-calendar'
      preLoaderRoute: typeof DashboardSalesCalendarImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/sales-contracts': {
      id: '/_dashboard/sales-contracts'
      path: '/sales-contracts'
      fullPath: '/sales-contracts'
      preLoaderRoute: typeof DashboardSalesContractsImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/sales-dashboard': {
      id: '/_dashboard/sales-dashboard'
      path: '/sales-dashboard'
      fullPath: '/sales-dashboard'
      preLoaderRoute: typeof DashboardSalesDashboardImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/sites': {
      id: '/_dashboard/sites'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof DashboardSitesImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/user-approvals': {
      id: '/_dashboard/user-approvals'
      path: '/user-approvals'
      fullPath: '/user-approvals'
      preLoaderRoute: typeof DashboardUserApprovalsImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/user-profile': {
      id: '/_dashboard/user-profile'
      path: '/user-profile'
      fullPath: '/user-profile'
      preLoaderRoute: typeof DashboardUserProfileImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/webhooks': {
      id: '/_dashboard/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof DashboardWebhooksImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/bom_/supplier-infos': {
      id: '/_dashboard/bom_/supplier-infos'
      path: '/bom/supplier-infos'
      fullPath: '/bom/supplier-infos'
      preLoaderRoute: typeof DashboardBomSupplierInfosImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/checklists_/$checklistId': {
      id: '/_dashboard/checklists_/$checklistId'
      path: '/checklists/$checklistId'
      fullPath: '/checklists/$checklistId'
      preLoaderRoute: typeof DashboardChecklistsChecklistIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/checklists_/create': {
      id: '/_dashboard/checklists_/create'
      path: '/checklists/create'
      fullPath: '/checklists/create'
      preLoaderRoute: typeof DashboardChecklistsCreateImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/invoice-print-templates_/$templateId': {
      id: '/_dashboard/invoice-print-templates_/$templateId'
      path: '/invoice-print-templates/$templateId'
      fullPath: '/invoice-print-templates/$templateId'
      preLoaderRoute: typeof DashboardInvoicePrintTemplatesTemplateIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/invoice-requests_/$invoiceRequestId': {
      id: '/_dashboard/invoice-requests_/$invoiceRequestId'
      path: '/invoice-requests/$invoiceRequestId'
      fullPath: '/invoice-requests/$invoiceRequestId'
      preLoaderRoute: typeof DashboardInvoiceRequestsInvoiceRequestIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/invoices_/$invoiceId': {
      id: '/_dashboard/invoices_/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof DashboardInvoicesInvoiceIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/leads_/$leadId': {
      id: '/_dashboard/leads_/$leadId'
      path: '/leads/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof DashboardLeadsLeadIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/leads_/import': {
      id: '/_dashboard/leads_/import'
      path: '/leads/import'
      fullPath: '/leads/import'
      preLoaderRoute: typeof DashboardLeadsImportImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/projects_/$projectId': {
      id: '/_dashboard/projects_/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof DashboardProjectsProjectIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/sales-contracts_/$contractId': {
      id: '/_dashboard/sales-contracts_/$contractId'
      path: '/sales-contracts/$contractId'
      fullPath: '/sales-contracts/$contractId'
      preLoaderRoute: typeof DashboardSalesContractsContractIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/sites_/$siteId': {
      id: '/_dashboard/sites_/$siteId'
      path: '/sites/$siteId'
      fullPath: '/sites/$siteId'
      preLoaderRoute: typeof DashboardSitesSiteIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/sites_/create': {
      id: '/_dashboard/sites_/create'
      path: '/sites/create'
      fullPath: '/sites/create'
      preLoaderRoute: typeof DashboardSitesCreateImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/user-approvals_/$userId': {
      id: '/_dashboard/user-approvals_/$userId'
      path: '/user-approvals/$userId'
      fullPath: '/user-approvals/$userId'
      preLoaderRoute: typeof DashboardUserApprovalsUserIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/bom_/supplier-infos_/$supplierInfoId': {
      id: '/_dashboard/bom_/supplier-infos_/$supplierInfoId'
      path: '/bom/supplier-infos/$supplierInfoId'
      fullPath: '/bom/supplier-infos/$supplierInfoId'
      preLoaderRoute: typeof DashboardBomSupplierInfosSupplierInfoIdImport
      parentRoute: typeof DashboardImport
    }
  }
}

// Create and export the route tree

interface DashboardRouteChildren {
  DashboardBir2307Route: typeof DashboardBir2307Route
  DashboardBomRoute: typeof DashboardBomRoute
  DashboardChangelogRoute: typeof DashboardChangelogRoute
  DashboardChecklistsRoute: typeof DashboardChecklistsRoute
  DashboardClientsRoute: typeof DashboardClientsRoute
  DashboardCollectionReportRoute: typeof DashboardCollectionReportRoute
  DashboardCreateRoute: typeof DashboardCreateRoute
  DashboardInvoicePrintTemplatesRoute: typeof DashboardInvoicePrintTemplatesRoute
  DashboardInvoiceRequestsRoute: typeof DashboardInvoiceRequestsRoute
  DashboardJournalAccountsRoute: typeof DashboardJournalAccountsRoute
  DashboardLeadsRoute: typeof DashboardLeadsRoute
  DashboardLeadsDashboardRoute: typeof DashboardLeadsDashboardRoute
  DashboardProjectsRoute: typeof DashboardProjectsRoute
  DashboardReportProjectsRoute: typeof DashboardReportProjectsRoute
  DashboardSalesCalendarRoute: typeof DashboardSalesCalendarRoute
  DashboardSalesContractsRoute: typeof DashboardSalesContractsRoute
  DashboardSalesDashboardRoute: typeof DashboardSalesDashboardRoute
  DashboardSitesRoute: typeof DashboardSitesRoute
  DashboardUserApprovalsRoute: typeof DashboardUserApprovalsRoute
  DashboardUserProfileRoute: typeof DashboardUserProfileRoute
  DashboardWebhooksRoute: typeof DashboardWebhooksRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardBomSupplierInfosRoute: typeof DashboardBomSupplierInfosRoute
  DashboardChecklistsChecklistIdRoute: typeof DashboardChecklistsChecklistIdRoute
  DashboardChecklistsCreateRoute: typeof DashboardChecklistsCreateRoute
  DashboardInvoicePrintTemplatesTemplateIdRoute: typeof DashboardInvoicePrintTemplatesTemplateIdRoute
  DashboardInvoiceRequestsInvoiceRequestIdRoute: typeof DashboardInvoiceRequestsInvoiceRequestIdRoute
  DashboardInvoicesInvoiceIdRoute: typeof DashboardInvoicesInvoiceIdRoute
  DashboardLeadsLeadIdRoute: typeof DashboardLeadsLeadIdRoute
  DashboardLeadsImportRoute: typeof DashboardLeadsImportRoute
  DashboardProjectsProjectIdRoute: typeof DashboardProjectsProjectIdRoute
  DashboardSalesContractsContractIdRoute: typeof DashboardSalesContractsContractIdRoute
  DashboardSitesSiteIdRoute: typeof DashboardSitesSiteIdRoute
  DashboardSitesCreateRoute: typeof DashboardSitesCreateRoute
  DashboardUserApprovalsUserIdRoute: typeof DashboardUserApprovalsUserIdRoute
  DashboardBomSupplierInfosSupplierInfoIdRoute: typeof DashboardBomSupplierInfosSupplierInfoIdRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardBir2307Route: DashboardBir2307Route,
  DashboardBomRoute: DashboardBomRoute,
  DashboardChangelogRoute: DashboardChangelogRoute,
  DashboardChecklistsRoute: DashboardChecklistsRoute,
  DashboardClientsRoute: DashboardClientsRoute,
  DashboardCollectionReportRoute: DashboardCollectionReportRoute,
  DashboardCreateRoute: DashboardCreateRoute,
  DashboardInvoicePrintTemplatesRoute: DashboardInvoicePrintTemplatesRoute,
  DashboardInvoiceRequestsRoute: DashboardInvoiceRequestsRoute,
  DashboardJournalAccountsRoute: DashboardJournalAccountsRoute,
  DashboardLeadsRoute: DashboardLeadsRoute,
  DashboardLeadsDashboardRoute: DashboardLeadsDashboardRoute,
  DashboardProjectsRoute: DashboardProjectsRoute,
  DashboardReportProjectsRoute: DashboardReportProjectsRoute,
  DashboardSalesCalendarRoute: DashboardSalesCalendarRoute,
  DashboardSalesContractsRoute: DashboardSalesContractsRoute,
  DashboardSalesDashboardRoute: DashboardSalesDashboardRoute,
  DashboardSitesRoute: DashboardSitesRoute,
  DashboardUserApprovalsRoute: DashboardUserApprovalsRoute,
  DashboardUserProfileRoute: DashboardUserProfileRoute,
  DashboardWebhooksRoute: DashboardWebhooksRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardBomSupplierInfosRoute: DashboardBomSupplierInfosRoute,
  DashboardChecklistsChecklistIdRoute: DashboardChecklistsChecklistIdRoute,
  DashboardChecklistsCreateRoute: DashboardChecklistsCreateRoute,
  DashboardInvoicePrintTemplatesTemplateIdRoute:
    DashboardInvoicePrintTemplatesTemplateIdRoute,
  DashboardInvoiceRequestsInvoiceRequestIdRoute:
    DashboardInvoiceRequestsInvoiceRequestIdRoute,
  DashboardInvoicesInvoiceIdRoute: DashboardInvoicesInvoiceIdRoute,
  DashboardLeadsLeadIdRoute: DashboardLeadsLeadIdRoute,
  DashboardLeadsImportRoute: DashboardLeadsImportRoute,
  DashboardProjectsProjectIdRoute: DashboardProjectsProjectIdRoute,
  DashboardSalesContractsContractIdRoute:
    DashboardSalesContractsContractIdRoute,
  DashboardSitesSiteIdRoute: DashboardSitesSiteIdRoute,
  DashboardSitesCreateRoute: DashboardSitesCreateRoute,
  DashboardUserApprovalsUserIdRoute: DashboardUserApprovalsUserIdRoute,
  DashboardBomSupplierInfosSupplierInfoIdRoute:
    DashboardBomSupplierInfosSupplierInfoIdRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sentry-error-test': typeof SentryErrorTestRoute
  '/bir-2307': typeof DashboardBir2307Route
  '/bom': typeof DashboardBomRoute
  '/changelog': typeof DashboardChangelogRoute
  '/checklists': typeof DashboardChecklistsRoute
  '/clients': typeof DashboardClientsRoute
  '/collection-report': typeof DashboardCollectionReportRoute
  '/create': typeof DashboardCreateRoute
  '/invoice-print-templates': typeof DashboardInvoicePrintTemplatesRoute
  '/invoice-requests': typeof DashboardInvoiceRequestsRoute
  '/journal-accounts': typeof DashboardJournalAccountsRoute
  '/leads': typeof DashboardLeadsRoute
  '/leads-dashboard': typeof DashboardLeadsDashboardRoute
  '/projects': typeof DashboardProjectsRoute
  '/report-projects': typeof DashboardReportProjectsRoute
  '/sales-calendar': typeof DashboardSalesCalendarRoute
  '/sales-contracts': typeof DashboardSalesContractsRoute
  '/sales-dashboard': typeof DashboardSalesDashboardRoute
  '/sites': typeof DashboardSitesRoute
  '/user-approvals': typeof DashboardUserApprovalsRoute
  '/user-profile': typeof DashboardUserProfileRoute
  '/webhooks': typeof DashboardWebhooksRoute
  '/': typeof DashboardIndexRoute
  '/bom/supplier-infos': typeof DashboardBomSupplierInfosRoute
  '/checklists/$checklistId': typeof DashboardChecklistsChecklistIdRoute
  '/checklists/create': typeof DashboardChecklistsCreateRoute
  '/invoice-print-templates/$templateId': typeof DashboardInvoicePrintTemplatesTemplateIdRoute
  '/invoice-requests/$invoiceRequestId': typeof DashboardInvoiceRequestsInvoiceRequestIdRoute
  '/invoices/$invoiceId': typeof DashboardInvoicesInvoiceIdRoute
  '/leads/$leadId': typeof DashboardLeadsLeadIdRoute
  '/leads/import': typeof DashboardLeadsImportRoute
  '/projects/$projectId': typeof DashboardProjectsProjectIdRoute
  '/sales-contracts/$contractId': typeof DashboardSalesContractsContractIdRoute
  '/sites/$siteId': typeof DashboardSitesSiteIdRoute
  '/sites/create': typeof DashboardSitesCreateRoute
  '/user-approvals/$userId': typeof DashboardUserApprovalsUserIdRoute
  '/bom/supplier-infos/$supplierInfoId': typeof DashboardBomSupplierInfosSupplierInfoIdRoute
}

export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sentry-error-test': typeof SentryErrorTestRoute
  '/bir-2307': typeof DashboardBir2307Route
  '/bom': typeof DashboardBomRoute
  '/changelog': typeof DashboardChangelogRoute
  '/checklists': typeof DashboardChecklistsRoute
  '/clients': typeof DashboardClientsRoute
  '/collection-report': typeof DashboardCollectionReportRoute
  '/create': typeof DashboardCreateRoute
  '/invoice-print-templates': typeof DashboardInvoicePrintTemplatesRoute
  '/invoice-requests': typeof DashboardInvoiceRequestsRoute
  '/journal-accounts': typeof DashboardJournalAccountsRoute
  '/leads': typeof DashboardLeadsRoute
  '/leads-dashboard': typeof DashboardLeadsDashboardRoute
  '/projects': typeof DashboardProjectsRoute
  '/report-projects': typeof DashboardReportProjectsRoute
  '/sales-calendar': typeof DashboardSalesCalendarRoute
  '/sales-contracts': typeof DashboardSalesContractsRoute
  '/sales-dashboard': typeof DashboardSalesDashboardRoute
  '/sites': typeof DashboardSitesRoute
  '/user-approvals': typeof DashboardUserApprovalsRoute
  '/user-profile': typeof DashboardUserProfileRoute
  '/webhooks': typeof DashboardWebhooksRoute
  '/': typeof DashboardIndexRoute
  '/bom/supplier-infos': typeof DashboardBomSupplierInfosRoute
  '/checklists/$checklistId': typeof DashboardChecklistsChecklistIdRoute
  '/checklists/create': typeof DashboardChecklistsCreateRoute
  '/invoice-print-templates/$templateId': typeof DashboardInvoicePrintTemplatesTemplateIdRoute
  '/invoice-requests/$invoiceRequestId': typeof DashboardInvoiceRequestsInvoiceRequestIdRoute
  '/invoices/$invoiceId': typeof DashboardInvoicesInvoiceIdRoute
  '/leads/$leadId': typeof DashboardLeadsLeadIdRoute
  '/leads/import': typeof DashboardLeadsImportRoute
  '/projects/$projectId': typeof DashboardProjectsProjectIdRoute
  '/sales-contracts/$contractId': typeof DashboardSalesContractsContractIdRoute
  '/sites/$siteId': typeof DashboardSitesSiteIdRoute
  '/sites/create': typeof DashboardSitesCreateRoute
  '/user-approvals/$userId': typeof DashboardUserApprovalsUserIdRoute
  '/bom/supplier-infos/$supplierInfoId': typeof DashboardBomSupplierInfosSupplierInfoIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sentry-error-test': typeof SentryErrorTestRoute
  '/_dashboard/bir-2307': typeof DashboardBir2307Route
  '/_dashboard/bom': typeof DashboardBomRoute
  '/_dashboard/changelog': typeof DashboardChangelogRoute
  '/_dashboard/checklists': typeof DashboardChecklistsRoute
  '/_dashboard/clients': typeof DashboardClientsRoute
  '/_dashboard/collection-report': typeof DashboardCollectionReportRoute
  '/_dashboard/create': typeof DashboardCreateRoute
  '/_dashboard/invoice-print-templates': typeof DashboardInvoicePrintTemplatesRoute
  '/_dashboard/invoice-requests': typeof DashboardInvoiceRequestsRoute
  '/_dashboard/journal-accounts': typeof DashboardJournalAccountsRoute
  '/_dashboard/leads': typeof DashboardLeadsRoute
  '/_dashboard/leads-dashboard': typeof DashboardLeadsDashboardRoute
  '/_dashboard/projects': typeof DashboardProjectsRoute
  '/_dashboard/report-projects': typeof DashboardReportProjectsRoute
  '/_dashboard/sales-calendar': typeof DashboardSalesCalendarRoute
  '/_dashboard/sales-contracts': typeof DashboardSalesContractsRoute
  '/_dashboard/sales-dashboard': typeof DashboardSalesDashboardRoute
  '/_dashboard/sites': typeof DashboardSitesRoute
  '/_dashboard/user-approvals': typeof DashboardUserApprovalsRoute
  '/_dashboard/user-profile': typeof DashboardUserProfileRoute
  '/_dashboard/webhooks': typeof DashboardWebhooksRoute
  '/_dashboard/': typeof DashboardIndexRoute
  '/_dashboard/bom_/supplier-infos': typeof DashboardBomSupplierInfosRoute
  '/_dashboard/checklists_/$checklistId': typeof DashboardChecklistsChecklistIdRoute
  '/_dashboard/checklists_/create': typeof DashboardChecklistsCreateRoute
  '/_dashboard/invoice-print-templates_/$templateId': typeof DashboardInvoicePrintTemplatesTemplateIdRoute
  '/_dashboard/invoice-requests_/$invoiceRequestId': typeof DashboardInvoiceRequestsInvoiceRequestIdRoute
  '/_dashboard/invoices_/$invoiceId': typeof DashboardInvoicesInvoiceIdRoute
  '/_dashboard/leads_/$leadId': typeof DashboardLeadsLeadIdRoute
  '/_dashboard/leads_/import': typeof DashboardLeadsImportRoute
  '/_dashboard/projects_/$projectId': typeof DashboardProjectsProjectIdRoute
  '/_dashboard/sales-contracts_/$contractId': typeof DashboardSalesContractsContractIdRoute
  '/_dashboard/sites_/$siteId': typeof DashboardSitesSiteIdRoute
  '/_dashboard/sites_/create': typeof DashboardSitesCreateRoute
  '/_dashboard/user-approvals_/$userId': typeof DashboardUserApprovalsUserIdRoute
  '/_dashboard/bom_/supplier-infos_/$supplierInfoId': typeof DashboardBomSupplierInfosSupplierInfoIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/login'
    | '/register'
    | '/reset-password'
    | '/sentry-error-test'
    | '/bir-2307'
    | '/bom'
    | '/changelog'
    | '/checklists'
    | '/clients'
    | '/collection-report'
    | '/create'
    | '/invoice-print-templates'
    | '/invoice-requests'
    | '/journal-accounts'
    | '/leads'
    | '/leads-dashboard'
    | '/projects'
    | '/report-projects'
    | '/sales-calendar'
    | '/sales-contracts'
    | '/sales-dashboard'
    | '/sites'
    | '/user-approvals'
    | '/user-profile'
    | '/webhooks'
    | '/'
    | '/bom/supplier-infos'
    | '/checklists/$checklistId'
    | '/checklists/create'
    | '/invoice-print-templates/$templateId'
    | '/invoice-requests/$invoiceRequestId'
    | '/invoices/$invoiceId'
    | '/leads/$leadId'
    | '/leads/import'
    | '/projects/$projectId'
    | '/sales-contracts/$contractId'
    | '/sites/$siteId'
    | '/sites/create'
    | '/user-approvals/$userId'
    | '/bom/supplier-infos/$supplierInfoId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/register'
    | '/reset-password'
    | '/sentry-error-test'
    | '/bir-2307'
    | '/bom'
    | '/changelog'
    | '/checklists'
    | '/clients'
    | '/collection-report'
    | '/create'
    | '/invoice-print-templates'
    | '/invoice-requests'
    | '/journal-accounts'
    | '/leads'
    | '/leads-dashboard'
    | '/projects'
    | '/report-projects'
    | '/sales-calendar'
    | '/sales-contracts'
    | '/sales-dashboard'
    | '/sites'
    | '/user-approvals'
    | '/user-profile'
    | '/webhooks'
    | '/'
    | '/bom/supplier-infos'
    | '/checklists/$checklistId'
    | '/checklists/create'
    | '/invoice-print-templates/$templateId'
    | '/invoice-requests/$invoiceRequestId'
    | '/invoices/$invoiceId'
    | '/leads/$leadId'
    | '/leads/import'
    | '/projects/$projectId'
    | '/sales-contracts/$contractId'
    | '/sites/$siteId'
    | '/sites/create'
    | '/user-approvals/$userId'
    | '/bom/supplier-infos/$supplierInfoId'
  id:
    | '__root__'
    | '/_dashboard'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/sentry-error-test'
    | '/_dashboard/bir-2307'
    | '/_dashboard/bom'
    | '/_dashboard/changelog'
    | '/_dashboard/checklists'
    | '/_dashboard/clients'
    | '/_dashboard/collection-report'
    | '/_dashboard/create'
    | '/_dashboard/invoice-print-templates'
    | '/_dashboard/invoice-requests'
    | '/_dashboard/journal-accounts'
    | '/_dashboard/leads'
    | '/_dashboard/leads-dashboard'
    | '/_dashboard/projects'
    | '/_dashboard/report-projects'
    | '/_dashboard/sales-calendar'
    | '/_dashboard/sales-contracts'
    | '/_dashboard/sales-dashboard'
    | '/_dashboard/sites'
    | '/_dashboard/user-approvals'
    | '/_dashboard/user-profile'
    | '/_dashboard/webhooks'
    | '/_dashboard/'
    | '/_dashboard/bom_/supplier-infos'
    | '/_dashboard/checklists_/$checklistId'
    | '/_dashboard/checklists_/create'
    | '/_dashboard/invoice-print-templates_/$templateId'
    | '/_dashboard/invoice-requests_/$invoiceRequestId'
    | '/_dashboard/invoices_/$invoiceId'
    | '/_dashboard/leads_/$leadId'
    | '/_dashboard/leads_/import'
    | '/_dashboard/projects_/$projectId'
    | '/_dashboard/sales-contracts_/$contractId'
    | '/_dashboard/sites_/$siteId'
    | '/_dashboard/sites_/create'
    | '/_dashboard/user-approvals_/$userId'
    | '/_dashboard/bom_/supplier-infos_/$supplierInfoId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SentryErrorTestRoute: typeof SentryErrorTestRoute
}

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SentryErrorTestRoute: SentryErrorTestRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_dashboard",
        "/login",
        "/register",
        "/reset-password",
        "/sentry-error-test"
      ]
    },
    "/_dashboard": {
      "filePath": "_dashboard.tsx",
      "children": [
        "/_dashboard/bir-2307",
        "/_dashboard/bom",
        "/_dashboard/changelog",
        "/_dashboard/checklists",
        "/_dashboard/clients",
        "/_dashboard/collection-report",
        "/_dashboard/create",
        "/_dashboard/invoice-print-templates",
        "/_dashboard/invoice-requests",
        "/_dashboard/journal-accounts",
        "/_dashboard/leads",
        "/_dashboard/leads-dashboard",
        "/_dashboard/projects",
        "/_dashboard/report-projects",
        "/_dashboard/sales-calendar",
        "/_dashboard/sales-contracts",
        "/_dashboard/sales-dashboard",
        "/_dashboard/sites",
        "/_dashboard/user-approvals",
        "/_dashboard/user-profile",
        "/_dashboard/webhooks",
        "/_dashboard/",
        "/_dashboard/bom_/supplier-infos",
        "/_dashboard/checklists_/$checklistId",
        "/_dashboard/checklists_/create",
        "/_dashboard/invoice-print-templates_/$templateId",
        "/_dashboard/invoice-requests_/$invoiceRequestId",
        "/_dashboard/invoices_/$invoiceId",
        "/_dashboard/leads_/$leadId",
        "/_dashboard/leads_/import",
        "/_dashboard/projects_/$projectId",
        "/_dashboard/sales-contracts_/$contractId",
        "/_dashboard/sites_/$siteId",
        "/_dashboard/sites_/create",
        "/_dashboard/user-approvals_/$userId",
        "/_dashboard/bom_/supplier-infos_/$supplierInfoId"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/sentry-error-test": {
      "filePath": "sentry-error-test.tsx"
    },
    "/_dashboard/bir-2307": {
      "filePath": "_dashboard.bir-2307.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/bom": {
      "filePath": "_dashboard.bom.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/changelog": {
      "filePath": "_dashboard.changelog.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/checklists": {
      "filePath": "_dashboard.checklists.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/clients": {
      "filePath": "_dashboard.clients.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/collection-report": {
      "filePath": "_dashboard.collection-report.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/create": {
      "filePath": "_dashboard.create.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/invoice-print-templates": {
      "filePath": "_dashboard.invoice-print-templates.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/invoice-requests": {
      "filePath": "_dashboard.invoice-requests.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/journal-accounts": {
      "filePath": "_dashboard.journal-accounts.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/leads": {
      "filePath": "_dashboard.leads.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/leads-dashboard": {
      "filePath": "_dashboard.leads-dashboard.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/projects": {
      "filePath": "_dashboard.projects.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/report-projects": {
      "filePath": "_dashboard.report-projects.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/sales-calendar": {
      "filePath": "_dashboard.sales-calendar.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/sales-contracts": {
      "filePath": "_dashboard.sales-contracts.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/sales-dashboard": {
      "filePath": "_dashboard.sales-dashboard.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/sites": {
      "filePath": "_dashboard.sites.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/user-approvals": {
      "filePath": "_dashboard.user-approvals.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/user-profile": {
      "filePath": "_dashboard.user-profile.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/webhooks": {
      "filePath": "_dashboard.webhooks.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/": {
      "filePath": "_dashboard.index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/bom_/supplier-infos": {
      "filePath": "_dashboard.bom_.supplier-infos.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/checklists_/$checklistId": {
      "filePath": "_dashboard.checklists_.$checklistId.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/checklists_/create": {
      "filePath": "_dashboard.checklists_.create.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/invoice-print-templates_/$templateId": {
      "filePath": "_dashboard.invoice-print-templates_.$templateId.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/invoice-requests_/$invoiceRequestId": {
      "filePath": "_dashboard.invoice-requests_.$invoiceRequestId.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/invoices_/$invoiceId": {
      "filePath": "_dashboard.invoices_.$invoiceId.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/leads_/$leadId": {
      "filePath": "_dashboard.leads_.$leadId.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/leads_/import": {
      "filePath": "_dashboard.leads_.import.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/projects_/$projectId": {
      "filePath": "_dashboard.projects_.$projectId.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/sales-contracts_/$contractId": {
      "filePath": "_dashboard.sales-contracts_.$contractId.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/sites_/$siteId": {
      "filePath": "_dashboard.sites_.$siteId.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/sites_/create": {
      "filePath": "_dashboard.sites_.create.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/user-approvals_/$userId": {
      "filePath": "_dashboard.user-approvals_.$userId.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/bom_/supplier-infos_/$supplierInfoId": {
      "filePath": "_dashboard.bom_.supplier-infos_.$supplierInfoId.tsx",
      "parent": "/_dashboard"
    }
  }
}
ROUTE_MANIFEST_END */
